import React from 'react';
import styled from 'styled-components';
import { Button, ButtonGroup } from '@material-ui/core';
import { FilterList as FilterListIcon } from '@material-ui/icons';

// common search filter button

const StyledButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
`;

export interface SearchFilterButtonProps {
  onClick?: () => void;
}

const SearchFilterButton: React.FC<SearchFilterButtonProps> = (
  props: SearchFilterButtonProps
) => {
  const { onClick } = props;
  return (
    <StyledButtonContainer>
      <ButtonGroup size='small' color='primary' variant='contained'>
        <Button onClick={onClick}>
          <FilterListIcon />
        </Button>
      </ButtonGroup>
    </StyledButtonContainer>
  );
};

export default SearchFilterButton;
